import React from 'react';
import * as S from './TravellerContactForm.styles';
import Icon from '../../../../../stories/core-components/IconsSelector';
import { TRAVELLER_CONTACT_FORM } from './../../../../containers/Review/Validation'

const TravellerContactForm = ({ isError, contactInfo, onChange, catCard, srCitizen, categoryCardInfo }: TRAVELLER_CONTACT_FORM) => {
  const { email, contactNum, emailErr, contactNumErr, contactNumMaxLength } = contactInfo

  return (
    <S.ContactForm id="TravllerContactBlock">
      <S.Container>
        <S.Email>
          <label>Email</label>
          <>
            <input className={`${contactInfo?.emailErr ? 'error' : ''}`} type="text" placeholder="Enter Email Address" value={email} data-val="email" onChange={onChange} />
            {emailErr ? <S.Error>{emailErr}</S.Error> : null}
          </>
        </S.Email>
        <S.MobileNumber>
          <label>Mobile Number</label>
          <>
            <S.MobileWrap>
              <S.CustomSelect className={`${contactInfo?.contactNumErr ? 'error' : ''}`}>
                <select>
                  <option>91</option>
                </select>
                <S.DropIconWrap>
                  <Icon
                    name="DropArrowIcon"
                    styleProps={{ width: '1.1rem', height: '1.1rem', fill: '#898b91' }}
                  />
                </S.DropIconWrap>
              </S.CustomSelect>
              <input className={`${contactInfo?.contactNumErr ? 'error' : ''}`} type="text" placeholder="Enter Mobile Number" maxLength={contactNumMaxLength} value={contactNum} data-val="contactNum" onChange={onChange} />
            </S.MobileWrap>
            {contactNumErr ? <S.Error>{contactNumErr}</S.Error> : null}
          </>
        </S.MobileNumber>

        {catCard ? <S.Block>
          <label>Cat card Number</label>
          <>
            <input className={`${contactInfo?.catCardErr ? 'error' : ''}`} type="text" placeholder="Enter CAT card Number" value={categoryCardInfo.catCardNumber} data-val="catCardNumber" onChange={onChange} />
            {categoryCardInfo.catCardErr ? <S.Error>{categoryCardInfo.catCardErr}</S.Error> : null}
          </>
        </S.Block> : null}

        {srCitizen ? <S.Block>
          <label>SrCitizen Card</label>
          <>
            <input className={`${contactInfo?.srCitizenCardErr ? 'error' : ''}`} type="text" placeholder="Enter Sr Citizen card Number" value={categoryCardInfo.srCitizenCardNumber} data-val="srCitizenCardNumber" onChange={onChange} />
            {categoryCardInfo.srCitizenCardErr ? <S.Error>{categoryCardInfo.srCitizenCardErr}</S.Error> : null}
          </>
        </S.Block> : null}
      </S.Container>
    </S.ContactForm>
  );
}

export default TravellerContactForm;
